"use strict";

angular
    .module("imagetrend.components")
    .directive("hlpFormBuilderQuestionsEdit", [
        function() {
            return {
                restrict: "AE",
                scope: {
                    component: "=?",
                    formType: "=?",
                    sets: "=?",
                    elements: "=?",
                    form: "=?",
                    resultSet: "=?",
                    parentComponent: "=?",
                    parameters: "=?",
                    attachments: "=?",
                    foreignDataSetChange: "&?"
                },
                controller: [
                    "$scope",
                    "$uibModal",
                    "DocumentTypes",
                    "$rootScope",
                    function ($scope, $uibModal, DocumentTypes, $rootScope) {
                        $scope.ssn_setting_options = [
                            { id: 0, name: "Masked" },
                            { id: 1, name: "Last 4 Visible" },
                            { id: 2, name: "Visible" }
                        ];

                        $scope.label_position_options = [
                            { id: true, name: "Top" },
                            { id: false, name: "Left" }
                        ];
                        $scope.true_false_options = [
                            { id: "true", name: "True" },
                            { id: "false", name: "False" }
                        ];
                        $scope.yes_no_options = [
                            { id: "true", name: "Yes" },
                            { id: "false", name: "No" }
                        ];

                        $scope.changeUpdateFromFormBasedOnDisabled = function (question) {
                            if (question.disabled === true) {
                                question.update_from_form = false;
                            }
                            else {
                                // Clear out the warning message
                                question.updateFromFormInstructions = null;
                            }
                        }

                        $scope.numberCheck = function (keyEvent) {
                            if (!/^[0-9]$/.test(keyEvent.key)) {
                                keyEvent.preventDefault();
                            }
                        }

                        $scope.stripDefaultValueNonDigits = function (question) {
                            if (typeof question.default_value === 'string') {
                                var stripped = question.default_value.replace(/\D/g, '').substring(0, 15);
                                if (stripped !== question.default_value) {
                                    question.default_value = stripped;
                                }
                            }
                        }

                        $scope.setUpdateFromFormInstructions = function (question) {
                            if (question.disabled === true && question.update_from_form === true) {
                                question.updateFromFormInstructions = "Warning: using update from form with disabled fields is not guaranteed to prevent users from updating values.";
                            }
                            else {
                                question.updateFromFormInstructions = null;
                            }
                        }
                        
                        $scope.applicationTypeExists = function(
                            component,
                            question
                        ) {
                            var exists = false;

                            if (
                                question.data_point_code ==
                                "certification_levels"
                            ) {
                                component.questions.forEach(function(q) {
                                    if (
                                        q.question_type.code ==
                                        "application_type"
                                    ) {
                                        question.required = q.required;
                                        question.disabled = q.disabled;
                                        question.update_from_form =
                                            q.update_from_form;
                                        exists = true;
                                    }
                                });
                            }

                            return exists;
                        };

                        DocumentTypes.getForForm().then(function(data) {
                            $scope.document_types = data;
                        });

                        $scope.questionOrderChanged = function(component) {
                            component.questions.forEach(function(
                                question,
                                index
                            ) {
                                question.sort_order = index + 1;
                                question.point.sort_order = index + 1;
                            });
                        };

                        $scope.saveQuestion = function(question) {
                            if (
                                !question.question_type.allow_sub_components &&
                                !question.allow_dynamic_addition &&
                                !question.allow_dynamic_edit &&
                                question.sub_components != null &&
                                question.sub_components.length > 0
                            ) {
                                $uibModal
                                    .open({
                                        animation: true,
                                        templateUrl:
                                            "templates/confirm/confirm.html",
                                        controller: "ConfirmModalController",
                                        resolve: {
                                            message: function() {
                                                return (
                                                    "The " +
                                                    question.question_type
                                                        .name +
                                                    " question type does not allow sub questions.\nAre you sure you want to save, which will remove all sub questions?"
                                                );
                                            }
                                        }
                                    })
                                    .result.then(function(result) {
                                        if (result) {
                                            question.sub_components = [];
                                            question.edit = false;
                                        } else {
                                            return;
                                        }
                                    });
                            } else {
                                question.edit = false;
                            }
                        };

                        $scope.addQuestion = function(component) {
                            if (component.questions == null) {
                                component.questions = [];
                            }

                            var label_position =
                                typeof $scope.form != "undefined" &&
                                $scope.form.label_position != null
                                    ? $scope.form.label_position
                                    : true;

                            component.questions.push({
                                id: guid(),
                                section_id: component.section_id,
                                component_id: component.id,
                                sort_order: component.questions.length,
                                sub_components: [],
                                edit: true,
                                required: false,
                                vertical: true,
                                multiple: false,
                                ssn_setting: 0,
                                file_upload_description: true,
                                file_upload_existing_docs: false,
                                disabled: false,
                                default_value: null,
                                label_position: label_position,
                                update_from_form: false,
                                share_files: false,
                                show_in_grid: false,
                                masked_setting: false
                            });
                        };

                        $scope.addSubComponent = function(question, component) {
                            if (question.sub_components == null) {
                                question.sub_components = [];
                            }

                            question.sub_components.push({
                                id: guid(),
                                parent_question_id: question.id,
                                sort_order: question.sub_components.length,
                                questions: [],
                                edit: true,
                                section_id: question.section_id,
                                component_conditions: [],
                                limit_document_type_ids: null,
                                limit_position_ids: null,
                                limit_license_level_ids: null,
                                limit_vehicle_type_ids: null,
                                skill_question_ids: null,
                                skill_show_points: null,
                                skill_default: null
                            });
                        };

                        $scope.removeComponent = function(components, index) {
                            $uibModal
                                .open({
                                    animation: true,
                                    templateUrl:
                                        "templates/confirm/confirm.html",
                                    controller: "ConfirmModalController",
                                    resolve: {
                                        message: function() {
                                            return "Are you sure you want to delete this component?";
                                        }
                                    }
                                })
                                .result.then(function(result) {
                                    if (result) {
                                        components.splice(index, 1);
                                    }
                                });
                        };

                        $scope.questionTypeInit = function (question, types) {
                            if (types.length > 0) {
                                if (question.question_type_id == null) {
                                    question.question_type_id = types[1].id;
                                    question.question_type = {};
                                }
                                types.forEach(function (type) {
                                    if (type.id == question.question_type_id) {
                                        question.question_type = type;
                                        if (type.code == "deficiency") {
                                            question.required = null;
                                        }
                                    }
                            });
                            }
                        };

                        $scope.questionTypeInit = function (question, types) {
                            // question type id for calculated_field
                            if (question.question_type_id == "b2932f47-8938-4999-92a6-f4a33ee55f8a" && types.length > 0) {
                                types.forEach(function (type) {
                                    if (type.id == question.question_type_id) {
                                        question.question_type = type;
                                    }
                                });
                            }
                            else if (
                                question.question_type_id == null &&
                                types.length > 0
                            ) {
                                question.question_type_id = types[1].id;
                                question.question_type = {};
                                types.forEach(function (type) {
                                    if (type.id == question.question_type_id) {
                                        question.question_type = type;
                                        if (type.code == "deficiency") {
                                            question.required = null;
                                        }
                                    }
                                });
                            }
                        };

                        $scope.questionTypeChange = function(question, types) {
                            if (question.question_type_id == null) {
                                question.question_type = {};
                            } else {
                                types.forEach(function(type) {
                                    if (type.id == question.question_type_id) {
                                        question.question_type = type;
                                        if (type.code == "deficiency") {
                                            question.required = null;
                                        }
                                    }
                                });
                            }
                        };

                        $scope.questionNameChange = function(question) {
                            if (question.old_name == question.label) {
                                question.label = question.name;
                            }
                            question.old_name = question.name;
                        };

                        $scope.removeQuestion = function(questions, index) {
                            $uibModal
                                .open({
                                    animation: true,
                                    templateUrl:
                                        "templates/confirm/confirm.html",
                                    controller: "ConfirmModalController",
                                    resolve: {
                                        message: function() {
                                            return "Are you sure you want to delete this question? Note that if this question is included in a form condition and/or conditional license charge, deleting it may cause unexpected results for the condition or charge. Please adjust any associated conditions and charges to remove this question.";
                                        }
                                    }
                                })
                                .result.then(function(result) {
                                    if (result) {
                                        questions.splice(index, 1);
                                    }
                                });
                        };

                        // Functions for editing and cancelling out of questions and components (works for both)
                        $scope.editElement = function(element) {
                            element.edit = true;
                            element.original = angular.copy(element);
                        };
                        $scope.revertElement = function(element) {
                            angular.copy(element.original, element);
                            element.edit = false;
                        };

                        $scope.questionOptions = function(component) {
                            return {
                                containment: "#component_" + component.id,
                                scrollableContainer:
                                    "#component_" + component.id,
                                containerPositioning: "relative",
                                accept: function(
                                    sourceItemHandleScope,
                                    destSortableScope
                                ) {
                                    return (
                                        sourceItemHandleScope.itemScope
                                            .sortableScope.$id ===
                                        destSortableScope.$id
                                    );
                                },
                                orderChanged: function(event) {
                                    if (
                                        component.component_type.code ==
                                        "dataset"
                                    ) {
                                        $scope.questionOrderChanged(component);
                                        $scope.form.the_form.$setDirty();
                                    }
                                }
                            };
                        };

                        $scope.subComponentOptions = function(question) {
                            return {
                                containment: "#subComponents_" + question.id,
                                scrollableContainer:
                                    "#subComponents_" + question.id,
                                containerPositioning: "relative",
                                accept: function(
                                    sourceItemHandleScope,
                                    destSortableScope
                                ) {
                                    return (
                                        sourceItemHandleScope.itemScope
                                            .sortableScope.$id ===
                                        destSortableScope.$id
                                    );
                                },
                                orderChanged: function(event) {
                                    $scope.form.the_form.$setDirty();
                                }
                            };
                        };

                        $scope.toggleValidation = function(question) {
                            question.showValidation =
                                typeof question.showValidation == "undefined"
                                    ? true
                                    : !question.showValidation;
                        };

                        $scope.getDocumentURL = function(component) {
                            return (
                                $rootScope.internalURL +
                                "controller.cfm?method=publicPortalService.openDocument" +
                                "&documentID=" +
                                component.document_id.toUpperCase() +
                                "&code=" +
                                component.document_code
                            );
                        };

                        $scope.checkIfImageOrPDF = function (component) {
                            if (component.document_file_name) {
                                var extensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf'];
                                return extensions.includes(component.document_file_name.split('.').pop().toLowerCase());
                            }
                            return false;
                        };
                    }
                ],
                replace: true,
                transclude: true,
                templateUrl:
                    "templates/form-builder/form-builder-questions-edit/form-builder-questions-edit.html",
                link: function(scope, elem, attrs, ctrl) {}
            };
        }
    ]);
